export const translations = {
  en: {
    nav: {
      home: "Home",
      about: "About Us",
      services: "Services",
      gallery: "Gallery",
      quote: "Get a Quote",
      contact: "Contact Us"
    },
    hero: {
      title_start: "Paysagiste A Catalogna",
      title_end: "Building Your Dreams",
      subtitle: "Residential and Commercial landscaping services that transform your outdoor space into a masterpiece.",
      cta_primary: "Start Your Project",
      cta_secondary: "View Our Work"
    },
    services: {
      title: "Our Services",
      subtitle: "Comprehensive landscaping solutions tailored to your specific needs, whether for your home or business.",
      tab_residential: "Residential",
      tab_commercial: "Commercial",
      
      // Residential Services
      res_garden_title: "Garden Design & Planting",
      res_garden_desc: "Custom garden layouts, flower beds, tree planting, and grass planting.",
      res_hardscape_title: "Hardscaping & Patios",
      res_hardscape_desc: "Beautiful stone patios, walkways, and outdoor living spaces.",
      res_asphalt_title: "Asphalt Paving",
      res_asphalt_desc: "Durable and smooth asphalt for driveways and walkways.",
      res_paveuni_title: "Pavé Uni (Pavers)",
      res_paveuni_desc: "Elegant interlocking pavers for a sophisticated look.",
      res_walls_title: "Retaining Walls",
      res_walls_desc: "Structural and decorative stone walls to manage slopes.",
      res_cement_title: "Cement Work",
      res_cement_desc: "Quality concrete work for stairs, curbs, and foundations.",
      res_rock_title: "Rock Gardens",
      res_rock_desc: "Low-maintenance, natural stone landscape features.",
      res_cedar_title: "Cedar Hedges",
      res_cedar_desc: "Privacy planting with lush, healthy cedar trees.",
      res_fence_title: "Residential Fencing",
      res_fence_desc: "Secure and stylish fencing solutions for your home.",
      res_drive_seal_title: "Driveway Sealing",
      res_drive_seal_desc: "Protective coating to extend the life of your asphalt.",
      res_pave_seal_title: "Pavé Uni Sealing",
      res_pave_seal_desc: "Sealant to protect pavers and enhance their natural colors.",
      res_wash_title: "Pressure Washing",
      res_wash_desc: "Deep cleaning for patios, driveways, and walkways.",

      // Commercial Services
      com_grounds_title: "Corporate Grounds Maintenance",
      com_grounds_desc: "Professional upkeep for office parks, retail centers, and industrial properties.",
      com_install_title: "Large Scale Installations",
      com_install_desc: "Complete landscape for commercial buildings."
    },
    areas: {
        west_island_title: "West Island Landscaping",
        west_island_desc: "Serving Beaconsfield, Pointe-Claire, and Kirkland with premium residential landscaping solutions. From spacious backyard transformations to elegant pool decks, we enhance the beauty of your West Island property.",
        tmr_title: "Town of Mount Royal (TMR)",
        tmr_desc: "Matching the prestige of TMR with high-end, manicured landscaping. We specialize in classic stone work, precise hedge trimming, and sophisticated garden designs for Mount Royal estates.",
        plateau_title: "The Plateau & Rosemont",
        plateau_desc: "Expert urban gardening for Montreal's heart. We specialize in small-space optimization, rooftop terraces, vertical gardens, and modern paving solutions perfectly suited for the Plateau and Rosemont.",
        south_shore_title: "South Shore & Laval",
        south_shore_desc: "Complete landscaping services for South Shore and Laval. Whether you need a durable new driveway, retaining walls, or a full garden renovation, we serve the wider metropolitan region with excellence."
    },
    features: {
      licensed: { title: "Licensed & Insured", desc: "Fully compliant for your peace of mind." },
      expert: { title: "Expert Team", desc: "Decades of combined experience in construction." },
      quality: { title: "Quality Materials", desc: "We use only the best products for longevity." },
      ontime: { title: "On-Time Completion", desc: "Respecting your time and schedule always." }
    },
    quote: {
      title: "Ready to Transform Your Space?",
      subtitle: "Get a free, no-obligation quote for your residential or commercial project. Contact us today!",
      form_title: "Get a Free Quote",
      form_subtitle: "Fill out the form below and we'll contact you shortly.",
      name: "Name",
      name_ph: "John Doe",
      phone: "Phone",
      phone_ph: "(555) 123-4567",
      email: "Email",
      email_ph: "john@example.com",
      service: "Service Type",
      project: "Project Details",
      project_ph: "Tell us about your project...",
      heard: "How did you hear about us?",
      heard_ph: "Select one (optional)",
      submit: "Submit Request",
      sending: "Sending...",
      success: "Quote request sent!",
      success_desc: "We'll get back to you within 24 hours.",
      error: "Submission failed",
      error_desc: "Please try again or call us directly."
    },
    sources: {
      google: "Google Search",
      social: "Facebook / Instagram",
      referral: "Referral (Friend/Family)",
      vehicle: "Truck / Sign",
      repeat: "Returning Customer",
      other: "Other"
    },
    service_types: {
      residential: "Residential Landscaping",
      commercial: "Commercial Landscaping",
      hardscape: "Hardscaping & Patios",
      maintenance: "Maintenance"
    },
    footer: {
      desc: "Premier landscaping and construction landscaping. Dedicated to quality, reliability, and beauty.",
      services_title: "Services",
      residential: "Pavé Uni (Pavers)",
      commercial: "Asphalt Paving",
      hardscaping: "Retaining Walls",
      area_title: "Service Area",
      area_desc: "Serving the greater Montreal area and the rest of the province of Quebec",
      west_island: "West Island",
      tmr: "Town of Mount Royal",
      plateau: "The Plateau / Rosemont",
      south_shore: "South Shore / Laval",
      copyright: "Paysagiste A Catalogna. All rights reserved."
    },
    about: {
      title_start: "About",
      title_end: "Us",
      subtitle: "We are more than just landscapers. We are artists, builders, and dreamers dedicated to transforming your outdoor world.",
      story_title: "Our Story",
      story_p1: "Catalogna Construction is a trusted name built over 40+ years in the construction industry. We have grown through experience, repeat business, and a commitment to doing things the right way with quality work, honest timelines, and professional project management from start to finish.",
      story_p2: "Our company has always believed in building more than structures. We help build communities. For decades, we also owned and operated the Catalogna Soccerplex in Lachine, a community landmark that required the same discipline and standards we apply to our construction projects, including safety, organization, and reliable execution.",
      story_p3: "Whether the job is large or small, our approach remains the same. We deliver strong workmanship, maintain clear communication, and complete every project with pride.",
      licensed: "Licensed & Insured",
      ontime: "On-Time Delivery",
      team_title: "Meet The Team",
      team_1_role: "Lead Landscape Architect",
      team_1_desc: "Expert in blending natural elements with modern design.",
      team_2_role: "Project Manager",
      team_2_desc: "Ensures every stone and shrub is placed to perfection.",
      team_3_role: "Maintenance Supervisor",
      team_3_desc: "Dedicated to keeping your property pristine year-round."
    },
    climate: {
      title: "The Montreal Climate Authority",
      subtitle: "Landscaping designed to survive and thrive in Zone 5b. Expert advice for Montreal's -30°C winters and hot humid summers.",
      intro_title: "Building for Extremes",
      intro_desc: "Montreal's climate is unforgiving. With freeze-thaw cycles that can heave foundations and winters that crack standard concrete, you need landscaping that is engineered, not just decorated. At Paysagiste A Catalogna, we don't just plant; we prepare.",
      
      plants_title: "Best Perennials for Montreal's Zone 5b",
      plants_desc: "Don't waste money on plants that won't come back. Here are our top picks for resilience and beauty in our specific hardiness zone:",
      plant_1_title: "Coneflower (Echinacea)",
      plant_1_desc: "Drought-tolerant and immune to deep freezes.",
      plant_2_title: "Hostas",
      plant_2_desc: "The king of Montreal shade gardens. Virtually indestructible once established.",
      plant_3_title: "Daylilies (Hemerocallis)",
      plant_3_desc: "Thrives in our humid summers and sleeps through the coldest winters.",
      
      stone_title: "Protecting Interlocking Stone from Salt & Ice",
      stone_desc: "Our winters are brutal on hardscaping. Here is how we ensure your driveway lasts 20+ years:",
      stone_tip_1_title: "Foundation First",
      stone_tip_1_desc: "We dig deeper (18-24 inches) using 0-3/4 crushed stone compaction to prevent frost heaving.",
      stone_tip_2_title: "Salt Alternatives",
      stone_tip_2_desc: "Never use rock salt on concrete pavers. We recommend calcium magnesium acetate (CMA) or simply using sand for traction.",
      stone_tip_3_title: "Polymeric Sand",
      stone_tip_3_desc: "We use high-grade polymeric sand that flexes with the freeze-thaw cycle, preventing cracks and weeds."
    },
    gallery: {
      title: "Our",
      title_red: "Gallery",
      subtitle: "Browse through our portfolio of completed projects.",
      all: "all",
      residential: "residential",
      commercial: "commercial",
      hardscape: "hardscape",
      maintenance: "maintenance",
      empty: "No projects in the gallery yet. Check back soon!",
      before: "Before",
      after: "After",
      slider_hint: "Drag the slider on each project to reveal the before & after."
    }
  },
  fr: {
    nav: {
      home: "Accueil",
      about: "À Propos",
      services: "Services",
      gallery: "Galerie",
      quote: "Obtenir un Devis",
      contact: "Nous Joindre"
    },
    hero: {
      title_start: "Paysagiste A Catalogna",
      title_end: "Bâtir Vos Rêves",
      subtitle: "Services d'aménagement paysager résidentiel et commercial pour transformer votre espace extérieur en chef-d'œuvre.",
      cta_primary: "Commencer Votre Projet",
      cta_secondary: "Voir Nos Réalisations"
    },
    services: {
      title: "Nos Services",
      subtitle: "Solutions d'aménagement paysager complètes adaptées à vos besoins spécifiques, pour votre maison ou votre entreprise.",
      tab_residential: "Résidentiel",
      tab_commercial: "Commercial",
      
      // Residential Services FR
      res_garden_title: "Design de Jardin & Plantation",
      res_garden_desc: "Aménagements personnalisés, parterres de fleurs, plantation d'arbres et pose de gazon.",
      res_hardscape_title: "Aménagement & Patios",
      res_hardscape_desc: "Magnifiques patios en pierre, allées et espaces de vie extérieurs.",
      res_asphalt_title: "Pavage d'Asphalte",
      res_asphalt_desc: "Asphalte durable et lisse pour allées et trottoirs.",
      res_paveuni_title: "Pavé Uni",
      res_paveuni_desc: "Pavés imbriqués élégants pour un look sophistiqué.",
      res_walls_title: "Murs de Soutènement",
      res_walls_desc: "Murs structurels et décoratifs pour gérer les pentes.",
      res_cement_title: "Travaux de Ciment",
      res_cement_desc: "Béton de qualité pour escaliers, bordures et fondations.",
      res_rock_title: "Jardins de Rocaille",
      res_rock_desc: "Aménagements en pierre naturelle nécessitant peu d'entretien.",
      res_cedar_title: "Haies de Cèdres",
      res_cedar_desc: "Plantation d'intimité avec des cèdres verts et luxuriants.",
      res_fence_title: "Clôture Résidentielle",
      res_fence_desc: "Solutions de clôture sécurisées et élégantes.",
      res_drive_seal_title: "Scellant d'Asphalte",
      res_drive_seal_desc: "Revêtement protecteur pour prolonger la vie de votre asphalte.",
      res_pave_seal_title: "Scellant de Pavé Uni",
      res_pave_seal_desc: "Scellant pour protéger les pavés et rehausser leurs couleurs.",
      res_wash_title: "Lavage à Pression",
      res_wash_desc: "Nettoyage en profondeur pour patios et allées.",

      // Commercial Services FR
      com_grounds_title: "Entretien de Terrains Corporatifs",
      com_grounds_desc: "Entretien professionnel pour parcs de bureaux, centres commerciaux et propriétés industrielles.",
      com_install_title: "Installations à Grande Échelle",
      com_install_desc: "Aménagement paysager complet pour bâtiments commerciaux."
    },
    areas: {
        west_island_title: "Aménagement Ouest-de-l'Île",
        west_island_desc: "Desservant Beaconsfield, Pointe-Claire et Kirkland avec des solutions d'aménagement résidentiel haut de gamme. Des transformations de grande cour aux contours de piscine élégants, nous rehaussons la beauté de votre propriété.",
        tmr_title: "Ville de Mont-Royal (VMR)",
        tmr_desc: "À la hauteur du prestige de VMR avec un aménagement soigné et haut de gamme. Nous nous spécialisons dans le travail de pierre classique, la taille précise de haies et les designs de jardin sophistiqués.",
        plateau_title: "Le Plateau & Rosemont",
        plateau_desc: "Jardinage urbain expert pour le cœur de Montréal. Nous nous spécialisons dans l'optimisation des petits espaces, les terrasses sur toit, les jardins verticaux et les solutions de pavage modernes.",
        south_shore_title: "Rive-Sud & Laval",
        south_shore_desc: "Services d'aménagement complets pour la Rive-Sud et Laval. Que vous ayez besoin d'une nouvelle allée durable, de murs de soutènement ou d'une rénovation complète de jardin, nous servons la grande région métropolitaine avec excellence."
    },
    features: {
      licensed: { title: "Licencié & Assuré", desc: "Entièrement conforme pour votre tranquillité d'esprit." },
      expert: { title: "Équipe Experte", desc: "Des décennies d'expérience combinée dans la construction." },
      quality: { title: "Matériaux de Qualité", desc: "Nous utilisons uniquement les meilleurs produits pour la longévité." },
      ontime: { title: "Achèvement à Temps", desc: "Respectant toujours votre temps et votre emploi du temps." }
    },
    quote: {
      title: "Prêt à Transformer Votre Espace ?",
      subtitle: "Obtenez un devis gratuit et sans engagement pour votre projet résidentiel ou commercial. Contactez-nous dès aujourd'hui !",
      form_title: "Obtenir un Devis Gratuit",
      form_subtitle: "Remplissez le formulaire ci-dessous et nous vous contacterons sous peu.",
      name: "Nom",
      name_ph: "Jean Dupont",
      phone: "Téléphone",
      phone_ph: "(555) 123-4567",
      email: "Courriel",
      email_ph: "jean@exemple.com",
      service: "Type de Service",
      project: "Détails du Projet",
      project_ph: "Parlez-nous de votre projet...",
      heard: "Comment avez-vous entendu parler de nous ?",
      heard_ph: "Choisissez une option (facultatif)",
      submit: "Envoyer la Demande",
      sending: "Envoi en cours...",
      success: "Demande de devis envoyée !",
      success_desc: "Nous vous répondrons dans les 24 heures.",
      error: "Échec de l'envoi",
      error_desc: "Veuillez réessayer ou nous appeler directement."
    },
    sources: {
      google: "Recherche Google",
      social: "Facebook / Instagram",
      referral: "Référence (Ami/Famille)",
      vehicle: "Camion / Enseigne",
      repeat: "Client de retour",
      other: "Autre"
    },
    service_types: {
      residential: "Aménagement Résidentiel",
      commercial: "Aménagement Paysager Commercial",
      hardscape: "Aménagement & Patios",
      maintenance: "Entretien"
    },
    footer: {
      desc: "Services d'aménagement paysager et de construction de premier plan. Dédiés à la qualité, la fiabilité et la beauté.",
      services_title: "Services",
      residential: "Pavé Uni",
      commercial: "Pavage d'Asphalte",
      hardscaping: "Murs de Soutènement",
      area_title: "Zone de Service",
      area_desc: "Desservant la grande région de Montréal et le reste de la province de Québec",
      west_island: "Ouest-de-l'Île",
      tmr: "Ville de Mont-Royal",
      plateau: "Le Plateau / Rosemont",
      south_shore: "Rive-Sud / Laval",
      copyright: "Paysagiste A Catalogna. Tous droits réservés."
    },
    about: {
      title_start: "À Propos",
      title_end: "De Nous",
      subtitle: "Nous sommes plus que de simples paysagistes. Nous sommes des artistes, des bâtisseurs et des rêveurs dédiés à transformer votre monde extérieur.",
      story_title: "Notre Histoire",
      story_p1: "Catalogna Construction est un nom de confiance bâti sur plus de 40 ans dans l'industrie de la construction. Nous avons grandi grâce à l'expérience, à la fidélité de nos clients et à notre engagement à bien faire les choses avec un travail de qualité, des délais honnêtes et une gestion de projet professionnelle du début à la fin.",
      story_p2: "Notre entreprise a toujours cru en la construction de plus que des structures. Nous aidons à bâtir des communautés. Pendant des décennies, nous avons également possédé et exploité le Soccerplex Catalogna à Lachine, un repère communautaire qui exigeait la même discipline et les mêmes normes que celles que nous appliquons à nos projets de construction, y compris la sécurité, l'organisation et une exécution fiable.",
      story_p3: "Que le travail soit grand ou petit, notre approche reste la même. Nous livrons un travail solide, maintenons une communication claire et terminons chaque projet avec fierté.",
      licensed: "Licencié & Assuré",
      ontime: "Livraison à Temps",
      team_title: "Rencontrez l'Équipe",
      team_1_role: "Architecte Paysagiste Principal",
      team_1_desc: "Expert dans le mélange d'éléments naturels avec un design moderne.",
      team_2_role: "Gestionnaire de Projet",
      team_2_desc: "S'assure que chaque pierre et arbuste est placé à la perfection.",
      team_3_role: "Superviseur de l'Entretien",
      team_3_desc: "Dédié à garder votre propriété impeccable toute l'année."
    },
    climate: {
      title: "L'Autorité Climatique de Montréal",
      subtitle: "Un aménagement conçu pour survivre et prospérer en Zone 5b. Conseils d'experts pour les hivers de -30°C et les étés humides de Montréal.",
      intro_title: "Construire pour les Extrêmes",
      intro_desc: "Le climat de Montréal est impitoyable. Avec des cycles de gel-dégel qui soulèvent les fondations et des hivers qui fissurent le béton standard, vous avez besoin d'un aménagement conçu par ingénierie, pas seulement décoré. Chez Paysagiste A Catalogna, nous ne faisons pas que planter ; nous préparons.",
      
      plants_title: "Meilleures Vivaces pour la Zone 5b",
      plants_desc: "Ne gaspillez pas d'argent sur des plantes qui ne reviendront pas. Voici nos meilleurs choix pour la résilience et la beauté dans notre zone de rusticité :",
      plant_1_title: "Échinacée (Coneflower)",
      plant_1_desc: "Tolérante à la sécheresse et immunisée contre les gels profonds.",
      plant_2_title: "Hostas",
      plant_2_desc: "Le roi des jardins ombragés montréalais. Pratiquement indestructible une fois établi.",
      plant_3_title: "Hémérocalles (Daylilies)",
      plant_3_desc: "Prospère dans nos étés humides et dort pendant les hivers les plus froids.",
      
      stone_title: "Protéger le Pavé Uni du Sel et de la Glace",
      stone_desc: "Nos hivers sont brutaux pour les aménagements. Voici comment nous assurons que votre allée dure plus de 20 ans :",
      stone_tip_1_title: "La Fondation d'Abord",
      stone_tip_1_desc: "Nous creusons plus profond (18-24 pouces) avec compaction de pierre concassée 0-3/4 pour prévenir le soulèvement par le gel.",
      stone_tip_2_title: "Alternatives au Sel",
      stone_tip_2_desc: "N'utilisez jamais de sel gemme sur les pavés de béton. Nous recommandons l'acétate de calcium-magnésium (CMA) ou simplement du sable pour l'adhérence.",
      stone_tip_3_title: "Sable Polymère",
      stone_tip_3_desc: "Nous utilisons un sable polymère de haute qualité qui fléchit avec le cycle gel-dégel, prévenant les fissures et les mauvaises herbes."
    },
    gallery: {
      title: "Notre",
      title_red: "Galerie",
      subtitle: "Parcourez notre portfolio de projets réalisés.",
      all: "tous",
      residential: "résidentiel",
      commercial: "commercial",
      hardscape: "aménagement",
      maintenance: "entretien",
      empty: "Aucun projet dans la galerie pour le moment. Revenez bientôt !",
      before: "Avant",
      after: "Après",
      slider_hint: "Glissez le curseur sur chaque projet pour révéler l'avant et l'après."
    }
  }
};
